import clsx from "clsx";
import React, { FunctionComponent, ReactNode } from "react";

import { LinearProgress } from "../LinearProgress";

type StatusBarProps = {
  children: [ReactNode, ReactNode];
  className?: string;
  isLoading: boolean;
};

export const StatusBar: FunctionComponent<StatusBarProps> = ({
  children,
  className,
  isLoading,
}) => {
  const [left, right] = children;
  return (
    <section className={clsx("tw-status-bar", className)}>
      {left}
      <LinearProgress
        className={clsx(
          "flex-1 h-[0.5px] hidden md:block",
          !isLoading && "invisible"
        )}
      />
      {right}
    </section>
  );
};
